import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "logo-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.85 16.72a7.25 7.25 0 1 1 7.87-7.87H21c.41 0 .75.34.75.75V21c0 .41-.34.75-.75.75H9.6a.75.75 0 0 1-.75-.75v-4.28ZM3.75 9.5a5.75 5.75 0 0 1 11.46-.65H9.6a.75.75 0 0 0-.75.75v5.61a5.75 5.75 0 0 1-5.1-5.71Zm12.95.85h3.55v9.9h-9.9V16.7a7.25 7.25 0 0 0 6.35-6.35Zm-1.51 0a5.75 5.75 0 0 1-4.84 4.84v-4.84h4.84Z"
    }, null, -1)
  ])))
}
export default { render: render }